<template>
  <div class="container">
    <div class="page__block">
      <h1 class="page__title h1">{{ title }}</h1>
    </div>
  </div>

  <div class="container">
    <div class="page__block">
      <GlobalSearch />
      <div action="" class="catalog-search" v-if="false">
        <div class="heading-for-aside">Поиск категории</div>
        <div class="catalog-search__body">
          <input
            v-model="search"
            type="search"
            class="catalog-search__input input-v2 input-v2_medium"
            placeholder="Я хочу найти..."
          />
          <button
            class="
              catalog-search__button
              button-v2 button-v2_transparent-3 button-v2_small
            "
          >
            <div class="button-v2__inner">
              <div class="button-v2__icon-box">
                <svg
                  preserveAspectRatio="none"
                  viewBox="0 0 24 24"
                  fill="none"
                  class="button-v2__icon"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.906 17.32a8 8 0 1 1 1.414-1.414l4.923 4.922-1.415 1.415-4.922-4.923zM17 11a6 6 0 1 1-12 0 6 6 0 0 1 12 0z"
                  />
                </svg>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="page__block">
      <div class="categories-set">
        <div
          v-for="group in groups_list"
          :key="group.id"
          class="categories-set__category"
        >
          <router-link
            :to="{ name: 'group', params: { group_slug: group.slug.split('_').join('-')} }"
            class="
              categories-set__category-link categories-set__category-link_name
            "
          >
            {{ group.name }}
          </router-link>
          <div class="categories-set__subcategories test">
            <router-link
              v-for="sub_category in group.sub_groups"
              :key="sub_category.id"
              :to="{ name: 'group', params: { group_slug: sub_category.slug.split('_').join('-') } }"
              class="
                categories-set__category-link categories-set__category-link_item
              "
            >
              {{ sub_category.name }}
              <!--({{ sub_category.products_count }})-->
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalSearch from "../components/GlobalSearch";
export default {
  name: "Catalog",
  data() {
    return {
      title: "Каталог",
      search: "",
    };
  },
  components: {
    GlobalSearch,
  },
  beforeMount() {
    this.$store.dispatch("groups_list/FETCH_DATA");
  },
  created() {
    this.$store.commit("bread_crumbs/INIT_CRUMBS");
  },
  computed: {
    groups_list() {
      return this.$store.getters["groups_list/GET_DATA"];
    },
  },
  watch: {
    search: function (text) {
      this.$store.dispatch("groups_list/FILTER", text);
    },
  },
};
</script>
